export default __webpack_public_path__ + "static/media/consorcioLogo.f051e1ae.svg";